import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { formatDZ } from '../../../utils/currency';
import Button from '../../../components/ui/Button';

const WishlistSection = ({ wishlistItems, onRemoveFromWishlist, onAddToCart, onMoveToCart }) => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Items', count: wishlistItems?.length },
    { id: 'phones', name: 'Phones', count: wishlistItems?.filter(item => item?.category === 'phones')?.length },
    { id: 'laptops', name: 'Laptops', count: wishlistItems?.filter(item => item?.category === 'laptops')?.length },
    { id: 'accessories', name: 'Accessories', count: wishlistItems?.filter(item => item?.category === 'accessories')?.length }
  ];

  const filteredItems = selectedCategory === 'all' 
    ? wishlistItems 
    : wishlistItems?.filter(item => item?.category === selectedCategory);

  return (
    <div className="holographic-card p-6 rounded-lg">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold command-text">My Wishlist</h2>
        <div className="flex items-center space-x-2">
          <Icon name="Heart" size={20} className="text-accent" />
          <span className="text-sm text-muted-foreground">{wishlistItems?.length} items</span>
        </div>
      </div>
      {/* Category Filters */}
      <div className="flex flex-wrap gap-2 mb-6">
        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => setSelectedCategory(category?.id)}
            className={`px-3 py-1 rounded-full text-sm font-medium transition-all duration-200 ${
              selectedCategory === category?.id
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
          >
            {category?.name} ({category?.count})
          </button>
        ))}
      </div>
      {/* Wishlist Items */}
      <div className="space-y-4">
        {filteredItems?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Heart" size={48} className="text-muted-foreground mx-auto mb-4" />
            <p className="text-muted-foreground">No items in this category</p>
          </div>
        ) : (
          filteredItems?.map((item) => (
            <div
              key={item?.id}
              className="border border-border rounded-lg p-4 hover:bg-muted/20 transition-all duration-200"
            >
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 bg-muted rounded-lg overflow-hidden flex-shrink-0">
                  <img
                    src={item?.image}
                    alt={item?.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.src = '/assets/images/no_image.png';
                    }}
                  />
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="font-medium text-foreground truncate">{item?.name}</h3>
                  <p className="text-sm text-muted-foreground mb-2">{item?.brand}</p>
                  <div className="flex items-center space-x-4">
                    <span className="font-bold text-primary">{formatDZ(item?.price)}</span>
                    {item?.originalPrice && item?.originalPrice > item?.price && (
                      <span className="text-sm text-muted-foreground line-through">
                        {formatDZ(item?.originalPrice)}
                      </span>
                    )}
                    {item?.inStock ? (
                      <span className="text-xs text-success flex items-center">
                        <div className="inventory-pulse high mr-1"></div>
                        In Stock
                      </span>
                    ) : (
                      <span className="text-xs text-error">Out of Stock</span>
                    )}
                  </div>
                  <p className="text-xs text-muted-foreground mt-1">
                    Added on {new Date(item.addedDate)?.toLocaleDateString()}
                  </p>
                </div>

                <div className="flex flex-col space-y-2">
                  <Button
                    variant="default"
                    size="sm"
                    disabled={!item?.inStock}
                    onClick={() => onMoveToCart(item?.id)}
                    iconName="ShoppingCart"
                    iconPosition="left"
                  >
                    Add to Cart
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onRemoveFromWishlist(item?.id)}
                    iconName="Trash2"
                    iconPosition="left"
                    className="text-error hover:text-error"
                  >
                    Remove
                  </Button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default WishlistSection;